export enum LevelConfigurationItemMode {
   PHYSICAL = "physical",
   VIRTUAL = "virtual",
}

export interface LevelConfigurationItem {
   id: string
   name: string
   mode: LevelConfigurationItemMode
   icon: string
   depth: number
   parent: string | null
}
